export default __webpack_public_path__ + "static/media/einstein-background.007d5038.svg";